import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from '../../localization';

function Winners(props) {
  return (
    <div>
      <div className='coming-soon-wrap d-flex justify-content-between align-items-center'>
        <h3>{Translate.comingSoon}</h3>
      </div>
    </div>
  )
}

Winners.propTypes = {}

export default Winners;
